import { Permission } from '@cims-online/shared'
import { CIMSTabs } from 'components/CIMSTabs'
import Connections from './components/Connections'
import Groups from './components/Groups'
import GroupsProvider from './components/Groups/GroupsContext'
import ConnectionsProvider from './components/Connections/ConnectionsContext'
import InternalConnections from './components/InternalConnections'
import InternalConnectionsProvider from './components/InternalConnections/InternalConnectionsContext'
import Order from './components/Order'

const Manage: React.FC = () => {
  const Tab = {
    Connections: 'Connections',
    Internals: 'Modules',
    Groups: 'Groups',
    Order: 'Order',
  } as const
  return (
    <CIMSTabs
      initialTab={Tab.Connections}
      tabs={[
        {
          permission: Permission.ViewPayItemConnection,
          key: Tab.Connections,
          label: Tab.Connections,
          component: (
            <ConnectionsProvider>
              <Connections />
            </ConnectionsProvider>
          ),
        },
        {
          permission: [
            Permission.ViewFieldDesignChange,
            Permission.ViewConstructionAdminSubmittal,
            Permission.ViewConcreteTestSet,
            Permission.ViewDesignSubmittal,
            Permission.ViewIssue,
            Permission.ViewEngineeringJudgement,
            Permission.ViewFieldDesignChange,
          ],
          key: Tab.Internals,
          label: Tab.Internals,
          component: (
            <InternalConnectionsProvider>
              <InternalConnections />
            </InternalConnectionsProvider>
          ),
        },
        {
          permission: Permission.ViewPayItemConnectionGroup,
          key: Tab.Groups,
          label: Tab.Groups,
          component: (
            <GroupsProvider>
              <Groups />
            </GroupsProvider>
          ),
        },
        {
          permission: Permission.ViewPayItemSummary,
          key: Tab.Order,
          label: Tab.Order,
          component: <Order />,
        },
      ]}
    />
  )
}

export default Manage
